export const SET_TABS = 'SET_TABS' as const;
export const SET_TAB = 'SET_TAB' as const;
export const DELETE_TAB = 'DELETE_TAB' as const;
